import React, { useState } from 'react';
import { AddTeamRequest, TeamResponse } from '../models/api';
import Button from './Button';
import Feedback from './Feedback';

type TeamsFormProps = {
  model: TeamResponse | null | undefined;
  submit: (e: AddTeamRequest) => Promise<boolean>;
  isSubmitting: boolean;
  errors: string[];
  close: () => void;
  buttonText: string;
};

const TeamsForm: React.FC<TeamsFormProps> = ({
  model,
  submit,
  isSubmitting,
  errors,
  close,
  buttonText
}) => {
  const [name, setName] = useState(model?.name ?? '');

  const handle = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const result = await submit({
      name
    });

    if (result) {
      setName('');
    }
  };

  return (
    <form onSubmit={handle} className="content-form">
      <div className="field">
        <label htmlFor="name">Name</label>
        <input
          id="name"
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="button-container">
        <Button
          className="action-button"
          isLoading={isSubmitting}
          isSubmit={true}
        >
          {buttonText}
        </Button>
        <button type="button" className="cancel-button" onClick={() => close()}>
          Cancel
        </button>
      </div>
      <Feedback messages={errors} type="error" />
    </form>
  );
};

export default TeamsForm;
